var _rect, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMessages = function SvgMessages(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "url(#Messages_svg__a)",
    rx: 24
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M24 11.016c-3.846 0-7.534 1.272-10.253 3.537S9.5 19.89 9.5 23.093c.004 2.084.654 4.131 1.888 5.943 1.235 1.813 3.01 3.328 5.156 4.4-.571 1.278-1.428 2.478-2.535 3.548 2.147-.377 4.162-1.168 5.889-2.313a17.2 17.2 0 0 0 4.102.5c3.846 0 7.534-1.273 10.253-3.537s4.247-5.337 4.247-8.54c0-3.204-1.528-6.276-4.247-8.54-2.72-2.266-6.407-3.538-10.253-3.538"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Messages_svg__a",
    x1: 24.381,
    x2: 24.381,
    y1: 44.814,
    y2: 5.957,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0CBD2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5BF675"
  })))));
};
export { SvgMessages as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDgiIGhlaWdodD0iNDgiIGZpbGw9Im5vbmUiPjxyZWN0IHdpZHRoPSI0OCIgaGVpZ2h0PSI0OCIgZmlsbD0idXJsKCNhKSIgcng9IjI0Ii8+PHBhdGggZmlsbD0iI2ZmZiIgZD0iTTI0IDExLjAxNmMtMy44NDYgMC03LjUzNCAxLjI3Mi0xMC4yNTMgMy41MzctMi43MiAyLjI2NS00LjI0NyA1LjMzNy00LjI0NyA4LjU0LjAwNCAyLjA4NC42NTQgNC4xMzEgMS44ODggNS45NDMgMS4yMzUgMS44MTMgMy4wMSAzLjMyOCA1LjE1NiA0LjQtLjU3MSAxLjI3OC0xLjQyOCAyLjQ3OC0yLjUzNSAzLjU0OCAyLjE0Ny0uMzc3IDQuMTYyLTEuMTY4IDUuODg5LTIuMzEzYTE3LjIxIDE3LjIxIDAgMCAwIDQuMTAyLjVjMy44NDYgMCA3LjUzNC0xLjI3MyAxMC4yNTMtMy41MzcgMi43Mi0yLjI2NSA0LjI0Ny01LjMzNyA0LjI0Ny04LjU0IDAtMy4yMDQtMS41MjgtNi4yNzYtNC4yNDctOC41NC0yLjcyLTIuMjY2LTYuNDA3LTMuNTM4LTEwLjI1My0zLjUzOFoiLz48ZGVmcz48bGluZWFyR3JhZGllbnQgaWQ9ImEiIHgxPSIyNC4zODEiIHgyPSIyNC4zODEiIHkxPSI0NC44MTQiIHkyPSI1Ljk1NyIgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiPjxzdG9wIHN0b3AtY29sb3I9IiMwQ0JEMkEiLz48c3RvcCBvZmZzZXQ9IjEiIHN0b3AtY29sb3I9IiM1QkY2NzUiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48L3N2Zz4=";